import { useState } from "react";

export default function ShareBar({ title }: { title: string }) {
  const [toast, setToast] = useState("");

  const showToast = (msg: string) => {
    setToast(msg);
    window.setTimeout(() => setToast(""), 2200);
  };

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      showToast("链接已复制，快分享给朋友吧");
    } catch {
      showToast("复制失败，请手动复制浏览器地址");
    }
  };

  const shareToWeibo = () => {
    const url = encodeURIComponent(window.location.href);
    window.open(
      `https://service.weibo.com/share/share.php?url=${url}&title=${encodeURIComponent(title)}`,
      "_blank",
      "noopener,noreferrer",
    );
    showToast("正在打开微博分享窗口");
  };

  const buttons = [
    { key: "wechat", label: "微信", icon: "ri-wechat-line", onClick: () => showToast("请点击浏览器菜单，将本页分享给微信好友") },
    { key: "weibo", label: "微博", icon: "ri-weibo-line", onClick: shareToWeibo },
    { key: "copy", label: "复制链接", icon: "ri-link", onClick: copyLink },
  ];

  return (
    <div className="relative mt-8 rounded-lg border border-background-200 bg-background-50 p-4">
      <div className="flex flex-wrap items-center gap-3">
        <span className="text-sm font-medium text-foreground-600">
          <i className="ri-share-forward-line mr-1"></i>分享这篇资讯
        </span>
        {buttons.map((btn) => (
          <button
            key={btn.key}
            type="button"
            onClick={btn.onClick}
            className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-200 px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:border-accent-300 hover:text-accent-600"
          >
            <i className={`${btn.icon} text-lg`}></i>
            {btn.label}
          </button>
        ))}
      </div>
      <p className="mt-3 text-xs text-foreground-400">
        * 本站分享功能为前端演示，不会调用真实的第三方分享接口。
      </p>
      {toast && (
        <div className="mt-3 inline-flex items-center gap-1.5 rounded-md bg-accent-100 px-3 py-2 text-xs text-accent-800 animate-fade-up">
          <i className="ri-checkbox-circle-line"></i>
          {toast}
        </div>
      )}
    </div>
  );
}